import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { Facebook } from '@ionic-native/facebook';
import { GooglePlus } from '@ionic-native/google-plus';

import { AuthService } from './auth.service';
import { BrowserStorageService } from '../../app/shared/storage.service';

import * as env from './env';

@NgModule({
  imports: [
    CommonModule,
    //AngularFireModule.initializeApp(env.firebaseConfig),
    AngularFireAuthModule
    ],
  declarations: [],
  providers: [
    AuthService,
    Facebook,
    GooglePlus,
    BrowserStorageService
  ],
  exports: []
})
export class AuthModule {}


// WEBPACK FOOTER //
// ./src/app/shared/auth.module.ts